export default "__VITE_ASSET__26623d61__"